module.exports = __webpack_public_path__ + "img/6-2.1dc501dd.png";